import React, { useEffect } from 'react';
import { modalEdit } from '../../redux/slices/modal.slice';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import styles from './index.module.scss';
import { subscriptionsSetAll } from '../../redux/slices/subscriptions.slice';
import { selectAll as selectAllSubscription } from '../../redux/slices/subscriptions.slice';
import OneSubscription from '../../components/OneSubscription';
import ExitReasonEntry from '../../components/ExitReasonEntry';
import { Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { errorEdit, loadingEdit } from '../../redux/slices/status.slice';
import { isMostPopular, EVERY_PLAN_INCLUDES, HELP_EMAIL, GUARANTEE_BEFORE_EMAIL, GUARANTEE_AFTER_EMAIL } from './planPresentation';

/*   Basic:
         Up to 3 rooms
         Up to 60 individual classes
         $249.99 / Year
Premium:
         Up to 5 rooms
         Up to 110 individual classes
         $349.99 / Year
Pro:
         Unlimited rooms
         Unlimited classes
         $499.99 / Year */
function Subscription() {
    const subscriptions = useSelector(selectAllSubscription);
    const dispatch = useDispatch();
    const { isAdmin, subscription } = useSelector(state => state.personality.user)
    const { loading, error } = useSelector(state => state.status)

    useEffect(() => {
        dispatch({ type: 'SUBSCRIPTIONS_GET_ALL' });
        return () => {
            dispatch(errorEdit(null));
            dispatch(loadingEdit(false))
        }
    }, [])

    // The buying view: a studio owner who has not chosen a plan yet. Admins manage plans
    // on this same page and existing customers see the one they are on, so neither of
    // those gets the picker heading or the shared feature line.
    const isPicking = !isAdmin && !(subscription?.length > 0);

    let count = 1;
    const addSubscription = () => {
        if (!isAdmin) return
        dispatch(modalEdit('Subscriptions'))
    }

    return (

        <>

            {!loading ? (
                <>
                    {error ? (<div className={styles.centerWrapper}>
                        <div className="text-danger">{error}</div>
                    </div>) : (<>  <div className="mainHeader">
                        <span>{isPicking ? 'Pick your plan' : 'Subscriptions'}</span>
                        {isAdmin ? (<Button onClick={addSubscription} className="addResourceButton text-decoration-none p-0 ms-3"
                            size="md"
                            variant="link">Add new +
                        </Button>) : null}

                    </div>
                        <div className={styles.subscriptions}>
                            <div className={styles.overlay}>

                                <Container className="py-0" fluid>
                                    <Row className="py-0">
                                        {subscription?.length > 0 ? (<>
                                            <OneSubscription data={{ subscriptionName: '', studiosNumber: subscription[0].studiosNumber, stickersNumber: subscription[0].stickersNumber, price: '', payment: subscription[0].validUntil, color: 'orange' }} />
                                        </>) : (<>
                                            {subscriptions.map((item, i) => {
                                                const payment = subscription?.id === item.id ? subscription.validUntil : false
                                                let color = 'Orange';
                                                if (count === 2) color = 'Green';
                                                if (count === 3) color = 'Magenta';
                                                count === 3 ? count = 1 : count++
                                                return (<Col className="px-0 " sm={12} lg={4} key={item.id} >
                                                    <div className={styles.subscription}>
                                                        <OneSubscription data={{ ...item, color, payment }} mostPopular={isPicking && isMostPopular(item.subscriptionName)} />
                                                    </div>
                                                </Col>)
                                            })}
                                        </>)}

                                    </Row>
                                    {isPicking ? (
                                        <>
                                            <div className={styles.included}>
                                                <strong>Every plan includes:</strong>{' '}
                                                <span>{EVERY_PLAN_INCLUDES.join(', ')}.</span>
                                            </div>
                                            <div className={styles.guarantee}>
                                                {GUARANTEE_BEFORE_EMAIL}{' '}
                                                <a href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</a>{' '}
                                                {GUARANTEE_AFTER_EMAIL}
                                            </div>
                                            <div className={styles.pickerFoot}>
                                                Not sure which one? Email{' '}
                                                <a href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</a>{' '}
                                                and we will help you pick.
                                            </div>
                                        </>
                                    ) : null}

                                    {/* Quiet by design, and below everything else on the
                                        page. It renders only for a studio that actually has
                                        a plan; see shouldShowAccountEntry. */}
                                    <ExitReasonEntry />
                                </Container>
                            </div>
                        </div></>)}

                </>
            ) : (
                <div className={styles.centerWrapper}>
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )}

        </>
    )
}


export default Subscription